import { throwError } from 'utils/throwError';

export interface AppConfig {
  hppUrl: string;
  backendUrl: string;
  siteKey: string | undefined;
  /** Set to true to restore the request-statement email button and notice. */
  isStatementEnabled: boolean;
}

export const appConfig: AppConfig = {
  hppUrl: process.env.REACT_APP_HPP_URL || throwError('HPP_URL cannot be undefined.'),
  backendUrl: process.env.REACT_APP_BACKEND_URL || throwError('BACKEND_URL cannot be undefined.'),
  siteKey: process.env.REACT_APP_SITE_KEY,
  isStatementEnabled: process.env.REACT_APP_IS_STATEMENT_ENABLED === 'true',
};
